import type { ApiPlayable } from "@hive/sdk";

export type CatalogueLevel = "SP" | "S" | "A" | "B" | "C";
export type CataloguePlayable = ApiPlayable & { catalogueLevel?: CatalogueLevel | null };
export function normalizeCatalogueLevel(value: unknown): CatalogueLevel | null {
	if (typeof value !== "string") return null;
	const level = value.trim().toUpperCase();
	return ["SP", "S", "A", "B", "C"].includes(level) ? level as CatalogueLevel : null;
}
export function playableLevel(item: CataloguePlayable): CatalogueLevel | null {
	if (item.catalogueLevel !== undefined) return normalizeCatalogueLevel(item.catalogueLevel);
	const spec = item.spec;
	return spec && typeof spec === "object" && "level" in spec ? normalizeCatalogueLevel(spec.level) : null;
}
